import store from '@/store';
import actions from '@/scripts/nav/actions';
import userGuide from '@/scripts/nav/userGuide';
import relatedInformation from '@/scripts/nav/relatedInformation';


//src\scripts\nav\menuItems.js, src\scripts\nav\actions.js, src\scripts\nav\adminActions.js, src\scripts\nav\userGuide.js, src\scripts\nav\relatedInformation.js
export default {
    menuItems: {
        rootMenus: {},
        indexPageItems: [],
        byName: {}
    },
    needsInitialization: true,
    initialize() {
        if (this.needsInitialization) {
            this.menuItems = buildMenuItems();
            this.needsInitialization = false;
        };
    },
    authorized
};

function fillOutMenuItem(details, menuItem) {

    if (details && menuItem && menuItem.name) {
        menuItem.groupName = details.name;
        if (!menuItem.name)
            menuItem.name = menuItem.isAuthorizedFor;
    }

    //menuItem, groupName
    menuItem.groupName = details.name;
    if (!menuItem.name) menuItem.name = menuItem.isAuthorizedFor;
}


function buildMenuItems() {
    const modules = [actions, userGuide, relatedInformation].map(m => m.get());
    const details = modules.map(m => m[process.env.VUE_APP_EXPOSURE]).filter(m => Boolean(m));
    const detailsWithMenus = details.filter(d => d.name && d.menu);

    detailsWithMenus.forEach(d => d.menu.forEach(m => fillOutMenuItem(d, m)));
    const allMenus = detailsWithMenus.map(d => d.menu).filter(i => Boolean(i));

    const allOther = details.map(d => d.other).filter(i => Boolean(i));
    allOther.push(masterIndex);
    const allItems = allMenus.concat(allOther).reduce((a, b) => a.concat(b));

    const byName = Object.assign(
        ...allItems.map(i => ({
            [i.name]: i
        }))
    );
    details.filter(m => Boolean(m.index)).forEach(m => byName[m.name] = m.index);

    const indexPageItems = allItems.filter(i => i.showOnIndexPage);

    const rootMenus = Object.assign(
        ...detailsWithMenus.map(i => ({
            [i.name]: i.menu
        }))
    );

    return {
        rootMenus,
        indexPageItems,
        byName
    };
}

var masterIndex = {
    name: 'analysis',
    url: '/analysis',
    title: 'BRFSS WEAT',
    description: 'BRFSS WEAT application home page'
};

function authorized(items) {
    return items.filter(m => {
        if (!m.isAuthorizedFor) {
            console.log('Application Error.  No isAuthorizedFor for ', m);
        }
        return (
            store.state.security.actions.indexOf(
                m.isAuthorizedFor.toLowerCase()
            ) >= 0
        );
    });
}